var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.title, attrs: { slot: "header" }, slot: "header" },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
          _c("div", { class: _vm.$style.notificationHead }, [
            _c("div", { class: _vm.$style.top }, [_vm._v("Contact Set")]),
            _c("div", { class: _vm.$style.main }, [_vm._v("Successfully")]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("p", [
            _vm._v(
              " You have successfully assigned " +
                _vm._s(_vm.bids.length) +
                " hotels(listed below) to " +
                _vm._s(_vm.contactName) +
                " at " +
                _vm._s(_vm.contactCompanyName) +
                ". "
            ),
          ]),
          _c(
            "ul",
            { class: _vm.$style.bids },
            _vm._l(_vm.names, function (name, index) {
              return _c("li", { key: index }, [
                _vm._v(" " + _vm._s(name) + " "),
              ])
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            { staticClass: "rbButton mainButton", class: _vm.$style.button },
            [_vm._v(" Okay ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }